import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  DialogActions,
  Grid,
  Paper,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core'
import { useConfirm } from 'material-ui-confirm'
import { useDispatch } from 'react-redux'

import styles from '../../../resources/theme/global'
import GlobalDropzone from '../../components/Dropzone'
import {
  uploadDocModel,
  getCurrentFileUrl,
  downloadOrcamentoModelExample,
} from '../SettingsActions'
import colors from '../../../assets/colors'
import filterStylesComponents from '../../../assets/filterComponentsStyles'

import '../../../resources/css/dropzone.css'
import { mdiMicrosoftExcel } from '@mdi/js'
import Icon from '@mdi/react'

const useStyles = makeStyles({
  box: {
    border: `1px dashed ${colors.graylight}`,
    borderRadius: '5px',
  },
  btnSystemModel: {
    textTransform: 'capitalize',
    height: '30px',
    padding: '10px 12px',
    color: '#FFFF',
    backgroundColor: colors.primary,
    fontWeight: 'normal',
    fontSize: '14px',
    margin: 0,
    borderRadius: '8px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.6,
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

function UploadDocModel({ classes }) {
  const confirm = useConfirm()
  const dispatch = useDispatch()
  const styles = useStyles()
  const [file, setFile] = useState([])
  const [currentFile, setCurrentFile] = useState(null)

  const handleDropFiles = files => {
    setFile(files[0])
  }

  const confirmChangeModel = () => {
    confirm({
      title: 'Alterar modelo de orçamento',
      description: 'Tem certeza que deseja alterar o modelo de orçamento?',
    }).then(() => {
      const formData = new FormData()
      formData.append('file', file)
      dispatch(uploadDocModel(formData))
    })
  }

  const filterStyles = filterStylesComponents()

  useEffect(() => {
    dispatch(getCurrentFileUrl()).then(data => {
      if (data && data.status === 200) {
        setCurrentFile(data.data)
      }
    })
  }, [])

  return (
    <Grid spacing={2} container>
      <Grid item xs={12}>
        <Box className={styles.box}>
          <GlobalDropzone
            handleChangeFiles={handleDropFiles}
            classes={classes}
            text="Clique aqui ou arraste documentos para selecionar"
            mimeTypes={[
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            ]}
            limit={1}
            maxSize={5242880}
          />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item>
            <Button
              className={styles.btnSystemModel}
              onClick={() => dispatch(downloadOrcamentoModelExample())}
            >
              <Icon
                path={mdiMicrosoftExcel}
                size={1}
                className={filterStyles.btnIcon}
                color="#FFFF"
              />
              Baixar modelo do sistema
            </Button>
          </Grid>
          <Grid item xs>
            <Box className={filterStyles.areaButtons}>
              {currentFile && (
                <Button
                  className={filterStyles.btnMoreFilters}
                  onClick={() => window.open(currentFile, '_blank')}
                >
                  <Icon
                    path={mdiMicrosoftExcel}
                    size={1}
                    className={filterStyles.btnIcon}
                    color={colors.primary}
                  />
                  Baixar modelo da lavanderia
                </Button>
              )}
              <Button
                className={filterStyles.btnSalvar}
                disabled={!file}
                onClick={confirmChangeModel}
              >
                Salvar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(UploadDocModel)
